import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';

import { NavController } from '@ionic/angular/standalone';

import { AuthService } from '@core/auth/services/auth.service';
import { PatientService } from '@core/services/patient.service';

import { type PatientAccountDto } from 'swagger-services/supertokens';

import { environment } from '../../../../environments/environment';

export const registrationGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const patientService = inject(PatientService);
  const navController = inject(NavController);
  const token = await authService.getTokenPayload();

  if (!token.patientId) {
    await navController.navigateForward([`workflow/${environment.workflowKeys.onboarding}`]);
    return false;
  }

  const patient = patientService.patientData() || (await patientService.fetchPatientData());

  if (isUserVerified(patient, token)) return true;

  await navController.navigateForward([`workflow/${environment.workflowKeys.onboarding}`]);
  return false;
};

function isUserVerified(patient: PatientAccountDto | undefined, token: any): boolean {
  if (!patient) return false;
  // TODO: Implement for isAddressVerified
  // return Boolean(patient.isEmailVerified && patient.isPhoneVerified && patient.isAddressVerified && token.trusted?.v);
  return Boolean(token.trusted?.v);
}
